import type { ExpressionSpecification } from 'mapbox-gl';

/** Map zoom at which note pins use their nominal screen width (40px batch, 50px draft in NotePinLayerService). */
export const NOTE_PIN_REFERENCE_ZOOM = 16;

/**
 * Mapbox `icon-size` expression: `baseEm` at `refZoom`, multiplied by `growthPerZoom` per zoom level in
 * (divided per level out), clamped to [minEm, maxEm].
 */
export function pinIconSizeMapboxExpression(
  baseEm: number,
  refZoom: number,
  minEm: number,
  maxEm: number,
  growthPerZoom = 2,
): ExpressionSpecification {
  const logGrowth = Math.log(growthPerZoom);
  const zoomAtMin = refZoom + Math.log(minEm / baseEm) / logGrowth;
  const zoomAtMax = refZoom + Math.log(maxEm / baseEm) / logGrowth;
  return ['interpolate', ['exponential', growthPerZoom], ['zoom'], zoomAtMin, minEm, zoomAtMax, maxEm];
}

/**
 * Mapbox `icon-offset` (icon px, scaled with `icon-size`) so the SVG tip stays on the lng/lat
 * when using `icon-anchor: bottom`.
 */
export function pinTipIconOffset(width: number, height: number, tipX: number, tipY: number): [number, number] {
  return [width / 2 - tipX, height - tipY];
}
